import { reactive, onBeforeMount } from "vue";
import { useTranslation } from "@/plugins/i18next/i18next";
export function useOrderReturnMsg() {
    const { t } = useTranslation();
    const feedbackAlert = reactive({
        color: null,
        message: null,
        show: false
    });
    onBeforeMount(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.has("feedback_msg_type")) {
            const type = params.get("feedback_msg_type");
            if (["success", "error", "warning", "info"].includes(type)) {
                const messageId = params.get("feedback_msg");
                feedbackAlert.message = t(messageId);
                switch (type) {
                    case "success":
                        feedbackAlert.color = "primary-light";
                        break;
                    case "info":
                        feedbackAlert.color = "primary-light";
                        break;
                    case "error":
                        feedbackAlert.color = "alert";
                        break;
                    case "warning":
                        feedbackAlert.color = "alert";
                        break;
                }
                feedbackAlert.show = true;
            }
        }
    });
    return {
        feedbackAlert
    };
}
